/* Round twenty-one (2026-08-30), delivery: the header's three inline
   scripts (the drawers controller from snippets/cl-topbar.liquid, the search
   drawer from snippets/cl-search-drawer.liquid, the locale suggestion bar
   from snippets/cl-locale-bar.liquid) as one cacheable asset, loaded once
   with defer by cl-topbar.liquid. No Liquid in here: the search drawer reads
   its routes, the price switch and the currency from data-cl-* attributes on
   #cl-search-drawer, the locale bar its names from its own JSON blob. Each
   block keeps its own ready guard, so a second run (the theme editor
   re-inserting the tag) is a no-op, exactly as the inline scripts were. */

/* ---------- drawers: region, contact, search ---------- */
(function () {
  /* One controller for both drawers. Bound on document rather than on the
     triggers themselves: below 991 the nav re-renders .cl-region-trigger and
     .cl-contact-trigger inside its own drawer, and that markup is not ours. */
  if (window.clTopbarReady) return;
  window.clTopbarReady = true;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SLIDE = 320;                       /* keep in step with --cl-drawer-slide in cl-topbar.css */
  var LOCK = 'cl-lock';                  /* on <html>; cl-base.css makes it overflow: hidden */
  var PICK_KEY = 'cl-region-pick';       /* localStorage: the visitor's own choice */
  var GEO_KEY = 'cl-region-geo';         /* sessionStorage: one lookup per session */
  var LANG_KEY = 'cl-region-lang';       /* localStorage: a language the visitor chose by hand */

  var lastTrigger = null;
  var openCount = 0;

  function byId(id) { return document.getElementById(id); }
  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function read(store, key) {
    try { return window[store] ? window[store].getItem(key) : null; } catch (err) { return null; }
  }
  function write(store, key, value) {
    try { if (window[store]) window[store].setItem(key, value); } catch (err) { /* private mode */ }
  }

  function triggersFor(id) {
    if (id === 'cl-region-drawer') return all('.cl-region-trigger');
    if (id === 'cl-search-drawer') return all('.cl-search-trigger');
    return all('.cl-contact-trigger');
  }

  /* ---------- drawer shell ---------- */

  /* The page lock is a class on <html> (html.cl-lock in cl-base.css) rather
     than an inline overflow, so cl-base.css can keep the scrollbar gutter
     reserved and the page does not shift when it lands. The nav's mobile menu
     sets the same class; when that menu is still open under a drawer it
     launched, the lock stays its to release. */
  function lock(on) {
    var html = document.documentElement;
    if (on) { html.classList.add(LOCK); return; }
    if (document.querySelector('.cl-nav.is-menu-open')) return;
    html.classList.remove(LOCK);
  }

  window.clOpenDrawer = function (id) { openDrawer(byId(id), null); };
  function openDrawer(el, trigger) {
    if (!el || el.open || el.clClosing) return;
    lastTrigger = trigger || null;

    if (openCount === 0) lock(true);
    openCount++;

    if (typeof el.showModal === 'function') el.showModal();
    else el.setAttribute('open', '');

    triggersFor(el.id).forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });

    /* The dialog was display: none until showModal(). Flush that layout
       before the open state lands, or the panel has no committed start
       transform and pops into place instead of sliding. */
    void el.offsetWidth;
    el.classList.add('is-open');

    /* the search drawer wants the field, every other one the close button */
    var first = el.querySelector('[data-cl-autofocus]') || el.querySelector('.cl-drawer__close');
    if (first) first.focus({ preventScroll: true });
  }

  function closeDrawer(el) {
    if (!el || !el.open || el.clClosing) return;
    var panel = el.querySelector('.cl-drawer__panel');
    var timer = null;
    var done = false;

    function finish() {
      if (done) return;
      done = true;
      clearTimeout(timer);
      if (panel) panel.removeEventListener('transitionend', onEnd);
      el.clClosing = false;
      if (typeof el.close === 'function') el.close();
      else el.removeAttribute('open');
    }
    function onEnd(e) {
      if (e.target === panel && e.propertyName === 'transform') finish();
    }

    /* Removing .is-open is the whole close motion: the panel returns to its
       base translateX(100%) and the backdrop to opacity 0 on the same curve.
       dialog.close() waits for the panel's transitionend so the top layer is
       not torn down mid-slide; the timer covers a transition that never
       ends (background tab, the panel re-laid out under it). */
    el.clClosing = true;
    el.classList.remove('is-open');
    if (REDUCED.matches || !panel) { finish(); return; }
    panel.addEventListener('transitionend', onEnd);
    timer = setTimeout(finish, SLIDE + 80);
  }

  function afterClose(el) {
    el.classList.remove('is-open');
    el.clClosing = false;
    openCount = openCount > 0 ? openCount - 1 : 0;
    if (openCount === 0) lock(false);
    triggersFor(el.id).forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    closeLists();
    if (lastTrigger && document.body.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
    lastTrigger = null;
  }

  /* ---------- phone sheet: drag the grip or the head to dismiss ---------- */

  /* Shared with the favourites list (cl-fav-nav.liquid picks it up from
     window). The panel follows the finger down, never up; past 90px or a
     quick flick it is sent the rest of the way and `onClose` runs once the
     slide has finished, otherwise it springs back. Mouse pointers are
     ignored: the side drawer on desktop has a close button. */
  window.clSheetDrag = function (panel, handles, onClose) {
    var startY = null, lastY = 0, lastT = 0, dy = 0;
    function onDown(e) {
      if (e.pointerType === 'mouse' || window.innerWidth > 767) return;
      startY = e.clientY; lastY = startY; lastT = e.timeStamp; dy = 0;
      panel.classList.add('is-dragging');
      try { e.currentTarget.setPointerCapture(e.pointerId); } catch (err) { /* gone */ }
    }
    function onMove(e) {
      if (startY === null) return;
      dy = Math.max(0, e.clientY - startY);
      var v = (e.clientY - lastY) / Math.max(1, e.timeStamp - lastT);
      lastY = e.clientY; lastT = e.timeStamp; panel._clV = v;
      panel.style.transform = 'translateY(' + dy + 'px)';
    }
    function onUp() {
      if (startY === null) return;
      startY = null;
      panel.classList.remove('is-dragging');
      var flick = (panel._clV || 0) > .6;
      if (dy > 90 || flick) {
        panel.style.transform = 'translateY(100%)';
        var done = false;
        var finish = function () { if (done) return; done = true; panel.removeEventListener('transitionend', finish); onClose(); panel.style.transform = ''; };
        panel.addEventListener('transitionend', finish);
        setTimeout(finish, SLIDE + 80);
      } else {
        panel.style.transform = '';
      }
    }
    handles.forEach(function (h) {
      if (!h) return;
      h.addEventListener('pointerdown', onDown);
      h.addEventListener('pointermove', onMove);
      h.addEventListener('pointerup', onUp);
      h.addEventListener('pointercancel', onUp);
    });
  };

  all('.cl-drawer').forEach(function (el) {
    var panel = el.querySelector('.cl-drawer__panel');
    if (panel) {
      window.clSheetDrag(panel, [el.querySelector('[data-cl-drawer-grip]'), el.querySelector('.cl-drawer__head')], function () {
        /* the panel is already off screen: close the dialog without the
           second slide closeDrawer would wait for */
        el.clClosing = false;
        if (typeof el.close === 'function') el.close(); else el.removeAttribute('open');
      });
    }

    /* Escape reaches a <dialog> as `cancel`, not as a cancellable keydown, so
       both the animated close and "the first Escape only shuts the open
       picker" have to be decided here. */
    el.addEventListener('cancel', function (e) {
      e.preventDefault();
      if (el.querySelector('[data-cl-list]:not([hidden])')) {
        closeLists();
        var back = el.querySelector('[data-cl-open-list]');
        if (back) back.focus({ preventScroll: true });
        return;
      }
      closeDrawer(el);
    });
    el.addEventListener('close', function () { afterClose(el); });
  });

  document.addEventListener('click', function (e) {
    var node = e.target;
    if (!node || !node.closest) return;

    /* Round eighteen: .cl-cart-trigger is no longer a drawer trigger; the
       header renders no cart drawer for it to open. */
    var trigger = node.closest('.cl-region-trigger, .cl-contact-trigger, .cl-search-trigger');
    if (trigger) {
      e.preventDefault();
      var id = trigger.classList.contains('cl-region-trigger') ? 'cl-region-drawer'
             : trigger.classList.contains('cl-search-trigger') ? 'cl-search-drawer' : 'cl-contact-drawer';
      openDrawer(byId(id), trigger);
      return;
    }

    if (node.closest('[data-cl-drawer-close]')) {
      closeDrawer(node.closest('.cl-drawer'));
      return;
    }

    /* A click on ::backdrop reports the dialog itself as the target, and the
       panel is a child, so this can only be the area outside the panel. */
    if (node.classList && node.classList.contains('cl-drawer')) closeDrawer(node);
  });

  /* ---------- region drawer ---------- */

  var region = byId('cl-region-drawer');
  if (!region) return;

  var form = region.querySelector('[data-cl-region-form]');
  var input = region.querySelector('[data-cl-country-input]');
  var valueFlag = region.querySelector('[data-cl-value-flag]');
  var valueName = region.querySelector('[data-cl-value-name]');
  var valueCurrency = region.querySelector('[data-cl-value-currency]');
  var geoBox = region.querySelector('[data-cl-geo-suggest]');
  var geoName = region.querySelector('[data-cl-geo-name]');
  var geoAccept = region.querySelector('[data-cl-geo-accept]');
  var deliveryNote = region.querySelector('[data-cl-delivery]');
  var dutiesNote = region.querySelector('[data-cl-duties]');
  var reprice = region.querySelector('[data-cl-reprice]');
  var filter = region.querySelector('[data-cl-filter]');
  var empty = region.querySelector('[data-cl-empty]');
  var countryRows = all('[data-cl-country]', region);
  var currencyRows = all('[data-cl-cur]', region);
  var localeInput = region.querySelector('[data-cl-locale-input]');
  var valueLanguage = region.querySelector('[data-cl-value-language]');
  var languageRows = all('[data-cl-lang]', region);
  /* The active country as the server rendered it. It stands in for a list row
     when Shopify reports no available_countries at all, so the notes and the
     summary still fill in against a one-country store. */
  var current = region.querySelector('[data-cl-current]');
  var startIso = input ? input.value : '';
  var pendingIso = startIso;
  var startLocale = localeInput ? localeInput.value : '';
  var pendingLocale = startLocale;

  /* EU membership decides the duties line, the way neverover's dutiesLine
     keys off its market list. Everything else is "auf Anfrage". */
  var EU = ',AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,DE,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SE,';

  function rowFor(iso) {
    for (var i = 0; i < countryRows.length; i++) {
      if (countryRows[i].getAttribute('data-cl-country') === iso) return countryRows[i];
    }
    if (current && current.getAttribute('data-cl-current') === iso) return current;
    return null;
  }

  function openList(name) {
    all('[data-cl-list]', region).forEach(function (list) {
      var on = list.getAttribute('data-cl-list') === name;
      if (on) list.removeAttribute('hidden'); else list.setAttribute('hidden', '');
    });
    all('[data-cl-open-list]', region).forEach(function (btn) {
      var on = btn.getAttribute('data-cl-open-list') === name;
      btn.classList.toggle('is-open', on);
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    if (!name) return;
    if (filter) { filter.value = ''; applyFilter(); }
    var open = region.querySelector('[data-cl-list="' + name + '"]');
    var selected = open ? open.querySelector('.is-selected') : null;
    if (selected && selected.scrollIntoView) selected.scrollIntoView({ block: 'nearest' });
    var search = open ? open.querySelector('[data-cl-filter]') : null;
    if (search) search.focus({ preventScroll: true });
  }
  function closeLists() { openList(null); }

  function applyFilter() {
    if (!filter) return;
    var q = filter.value.replace(/^\s+|\s+$/g, '').toLowerCase();
    var shown = 0;
    countryRows.forEach(function (row) {
      var hay = (row.getAttribute('data-cl-name') + ' ' +
                 row.getAttribute('data-cl-country') + ' ' +
                 row.getAttribute('data-cl-currency')).toLowerCase();
      var hit = !q || hay.indexOf(q) !== -1;
      row.parentNode[hit ? 'removeAttribute' : 'setAttribute']('hidden', '');
      if (hit) shown++;
    });
    if (empty) empty[shown === 0 ? 'removeAttribute' : 'setAttribute']('hidden', '');
  }

  /* The selected value is ALWAYS the market Shopify is serving (or the one
     the visitor has just picked in this drawer). A geolocation hit never
     writes into it: it only fills the suggestion row below the field, so the
     strip and the drawer can never disagree about where the visitor is. */
  function select(iso) {
    var row = rowFor(iso);
    if (!row) return;
    pendingIso = iso;

    var name = row.getAttribute('data-cl-name');
    var currency = row.getAttribute('data-cl-currency');
    var symbol = row.getAttribute('data-cl-symbol');
    var flag = row.querySelector('.cl-flag');

    if (input) input.value = iso;
    if (valueFlag && flag) valueFlag.innerHTML = flag.outerHTML;
    if (valueName) valueName.textContent = name;
    if (valueCurrency) valueCurrency.textContent = currency + (symbol ? ' · ' + symbol : '');
    /* once the suggested country is the one selected, the suggestion is moot */
    if (geoBox && geoBox.getAttribute('data-cl-geo-suggest') === iso) geoBox.setAttribute('hidden', '');

    countryRows.forEach(function (r) {
      r.classList.toggle('is-selected', r.getAttribute('data-cl-country') === iso);
    });
    currencyRows.forEach(function (r) {
      r.classList.toggle('is-selected', r.getAttribute('data-cl-cur') === currency);
    });

    var inEu = EU.indexOf(',' + iso.toUpperCase() + ',') !== -1;
    var de = ((document.documentElement.getAttribute('lang') || 'de').slice(0, 2).toLowerCase() === 'de');
    if (deliveryNote) {
      deliveryNote.textContent = de
        ? 'Lieferung nach ' + name + (inEu ? ' · Versand innerhalb der EU' : ' · Versand auf Anfrage')
        : 'Delivery to ' + name + (inEu ? ' · shipping within the EU' : ' · shipping on request');
    }
    if (dutiesNote) {
      dutiesNote.textContent = de
        ? (inEu ? 'Preise inkl. MwSt. · innerhalb der EU fallen keine Zollgebühren an' : 'Zoll und Einfuhrsteuern werden im Checkout ausgewiesen')
        : (inEu ? 'Prices include VAT · no customs duties within the EU' : 'Duties and import taxes are shown at checkout');
    }
    if (reprice) {
      if (iso === startIso) reprice.setAttribute('hidden', '');
      else {
        reprice.textContent = de
          ? 'Ihr Warenkorb wird in ' + currency + ' neu berechnet. Nicht jedes Modell ist in jeden Markt lieferbar.'
          : 'Your cart is recalculated in ' + currency + '. Not every model ships to every market.';
        reprice.removeAttribute('hidden');
      }
    }
  }

  /* Language is independent of country: Shopify takes locale_code and
     country_code in the same form, so a visitor in Germany can read English
     without leaving the German market and its prices. */
  function selectLanguage(iso) {
    if (!iso) return;
    var row = null;
    for (var i = 0; i < languageRows.length; i++) {
      if (languageRows[i].getAttribute('data-cl-lang') === iso) { row = languageRows[i]; break; }
    }
    if (!row) return;
    pendingLocale = iso;
    if (localeInput) localeInput.value = iso;
    if (valueLanguage) valueLanguage.textContent = row.getAttribute('data-cl-lang-name') || iso.toUpperCase();
    languageRows.forEach(function (r) {
      r.classList.toggle('is-selected', r.getAttribute('data-cl-lang') === iso);
    });
    if (window.clLangSuggestSettled) window.clLangSuggestSettled(iso);
  }

  region.addEventListener('click', function (e) {
    var node = e.target;
    if (!node || !node.closest) return;

    var opener = node.closest('[data-cl-open-list]');
    if (opener) {
      var name = opener.getAttribute('data-cl-open-list');
      openList(opener.classList.contains('is-open') ? null : name);
      return;
    }

    var country = node.closest('[data-cl-country]');
    if (country) { select(country.getAttribute('data-cl-country')); dismiss('countries'); return; }

    var language = node.closest('[data-cl-lang]');
    if (language) { selectLanguage(language.getAttribute('data-cl-lang')); dismiss('languages'); return; }

    var currency = node.closest('[data-cl-cur]');
    if (currency) {
      /* Shopify prices per market country, so a currency pick has to land on
         a country: take the first one billed in it. */
      var want = currency.getAttribute('data-cl-cur');
      for (var i = 0; i < countryRows.length; i++) {
        if (countryRows[i].getAttribute('data-cl-currency') === want) {
          select(countryRows[i].getAttribute('data-cl-country'));
          break;
        }
      }
      dismiss('currencies');
    }
  });

  if (geoAccept) {
    geoAccept.addEventListener('click', function () {
      var iso = geoBox ? geoBox.getAttribute('data-cl-geo-suggest') : '';
      if (iso) select(iso);
    });
  }

  /* Picking a row hides the row, so focus has to go back to the field it
     belongs to or it lands on <body> and the next Tab restarts the drawer. */
  function dismiss(name) {
    closeLists();
    var field = region.querySelector('[data-cl-open-list="' + name + '"]');
    if (field) field.focus({ preventScroll: true });
  }

  if (filter) filter.addEventListener('input', applyFilter);

  if (form) {
    form.addEventListener('submit', function () {
      /* The commit is the visitor's own decision, so record it: the geo
         suggestion below must never overrule it on a later visit. Same rule
         as neverover's "geo never overrides a cookie". */
      write('localStorage', PICK_KEY, pendingIso);
      if (pendingLocale && pendingLocale !== startLocale) write('localStorage', LANG_KEY, pendingLocale);
    });
  }

  select(startIso);
  window.clRegionPickLanguage = selectLanguage;
  window.clRegionShowCountry = function (iso) { select(iso); if (geoBox) geoBox.setAttribute('hidden', ''); };
  window.clRegionSubmit = function () { if (form) form.requestSubmit ? form.requestSubmit() : form.submit(); };

  /* ---------- geolocation suggestion ---------- */

  /* A hit that differs from the served market fills the suggestion row
     ("Sie scheinen in X zu sein") with a button that selects it. The field
     itself is left alone; see select(). */
  function suggest(iso) {
    if (!iso || !geoBox) return;
    iso = iso.toUpperCase();
    if (iso === startIso.toUpperCase()) return;
    var row = rowFor(iso);
    if (!row || row === current) return;
    geoBox.setAttribute('data-cl-geo-suggest', iso);
    if (geoName) geoName.textContent = row.getAttribute('data-cl-name');
    geoBox.removeAttribute('hidden');
  }

  /* The lookup used to be invisible unless it disagreed with the served market.
     Now it labels itself: the row it detected carries a badge in the list, so
     opening the picker tells you what was detected and that it was detected,
     rather than leaving the visitor to guess why a country is preselected. */
  function markAuto(iso, langIso) {
    if (iso) {
      var want = iso.toUpperCase();
      countryRows.forEach(function (r) {
        r.classList.toggle('is-auto', (r.getAttribute('data-cl-country') || '').toUpperCase() === want);
      });
      if (current) current.classList.toggle('is-auto', (current.getAttribute('data-cl-current') || '').toUpperCase() === want);
    }
    if (langIso) {
      var wantLang = langIso.toLowerCase();
      languageRows.forEach(function (r) {
        r.classList.toggle('is-auto', (r.getAttribute('data-cl-lang') || '').toLowerCase() === wantLang);
      });
    }
  }

  function prefetchGeo() {
    /* A manual pick stops the SUGGESTION, not the badge: knowing what was
       detected is still useful once you have overridden it. */
    var picked = read('localStorage', PICK_KEY);

    var cached = read('sessionStorage', GEO_KEY);
    if (cached !== null) {
      if (!picked) suggest(cached);
      markAuto(cached, read('sessionStorage', GEO_KEY + '-lang') || '');
      return;
    }
    if (!window.fetch) return;

    var controller = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, 2500);

    /* Shopify serves this on the storefront; it 404s in the preview harness
       and on any non-Shopify host, which is why the whole thing is wrapped
       and the failure is written to the session cache as "nothing". */
    fetch('/browsing_context_suggestions.json', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: controller ? controller.signal : undefined
    })
      .then(function (res) {
        if (!res.ok) throw new Error('no suggestion');
        return res.json();
      })
      .then(function (data) {
        var found = (data && data.detected_values) || {};
        var detected = found.country;
        var iso = detected && (detected.handle || detected.iso_code) || '';
        var detectedLang = found.language;
        var langIso = detectedLang && (detectedLang.handle || detectedLang.iso_code) || '';
        write('sessionStorage', GEO_KEY, iso);
        write('sessionStorage', GEO_KEY + '-lang', langIso);
        if (!picked) suggest(iso);
        markAuto(iso, langIso);
      })
      .catch(function () { write('sessionStorage', GEO_KEY, ''); })
      .then(function () { clearTimeout(timer); });
  }

  if (window.requestIdleCallback) window.requestIdleCallback(prefetchGeo, { timeout: 3000 });
  else setTimeout(prefetchGeo, 1200);
})();

/* ---------- search drawer ---------- */
(function () {
  var el = document.getElementById('cl-search-drawer');
  if (!el || el.dataset.clSearchReady === '1') return;
  el.dataset.clSearchReady = '1';

  var form = el.querySelector('[data-cl-search-form]');
  var input = el.querySelector('[data-cl-search-input]');
  var clear = el.querySelector('[data-cl-search-clear]');
  var dflt = el.querySelector('[data-cl-search-default]');
  var results = el.querySelector('[data-cl-search-results]');
  var prodBox = el.querySelector('[data-cl-search-products]');
  var prodList = el.querySelector('[data-cl-search-products-list]');
  var artBox = el.querySelector('[data-cl-search-articles]');
  var artList = el.querySelector('[data-cl-search-articles-list]');
  var empty = el.querySelector('[data-cl-search-empty]');
  var all = el.querySelector('[data-cl-search-all]');
  var searchUrl = el.getAttribute('data-cl-search-url') || '/search';
  var predictUrl = el.getAttribute('data-cl-predict-url') || '/search/suggest';
  var timer = null, seq = 0;

  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* Predictive search returns the original CDN file (1 to 3 MB renders). A
     Shopify image URL takes a size before the extension, so the row asks
     for a 100px square first and swaps to a 260px one once that has
     loaded; the row is 3.25rem, so the small copy is already sharp at 1x
     and the swap only serves 2x screens. */
  function sized(url, size) {
    if (!url || /_\d+x\d+(_crop_\w+)?\.[a-z]{3,4}(\?|$)/i.test(url)) return url;
    return url.replace(/(\.[a-z]{3,4})(\?[^#]*)?$/i, '_' + size + '$1$2');
  }
  function thumb(url) {
    if (!url) return '';
    var small = sized(url, '100x100'), full = sized(url, '260x260');
    return '<img src="' + esc(small) + '" alt="" decoding="async"' + (full !== small ? ' data-cl-full="' + esc(full) + '"' : '') + '>';
  }
  function upgrade(list) {
    if (!list) return;
    list.querySelectorAll('img[data-cl-full]').forEach(function (img) {
      var full = img.getAttribute('data-cl-full');
      img.removeAttribute('data-cl-full');
      var swap = function () { img.src = full; };
      if (img.complete && img.naturalWidth > 0) swap();
      else img.addEventListener('load', swap, { once: true });
    });
  }
  /* Round nineteen: with Theme settings > Commerce > show_prices off, a
     result row is title only; the predictive API still answers with a
     price, so the switch is applied here. `show_prices` is a render param:
     `settings` inside this snippet is the nav section's, not the theme's. */
  var SHOW_PRICES = el.getAttribute('data-cl-show-prices') === 'true';
  function money(cents) {
    try { return (cents / 100).toLocaleString(document.documentElement.lang || 'de', { style: 'currency', currency: el.getAttribute('data-cl-currency') || 'EUR' }); }
    catch (e) { return ''; }
  }
  function showDefault() {
    if (dflt) dflt.hidden = false;
    if (results) results.hidden = true;
    if (clear) clear.hidden = true;
  }
  function render(data, q) {
    var res = (data && data.resources && data.resources.results) || {};
    var products = res.products || [], articles = res.articles || [];
    if (prodList) prodList.innerHTML = products.map(function (p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
      var price = SHOW_PRICES && p.price != null ? (typeof p.price === 'string' ? p.price : money(p.price)) : '';
      return '<a class="cl-search__row" href="' + esc(p.url) + '">' +
        '<span class="cl-search__row-image">' + thumb(img) + '</span>' +
        '<span class="cl-search__row-text"><span class="cl-search__row-title">' + esc(p.title) + '</span>' +
        (price ? '<span class="cl-search__row-sub">' + esc(price) + '</span>' : '') + '</span></a>';
    }).join('');
    if (artList) artList.innerHTML = articles.map(function (a) {
      var img = a.image || '';
      return '<a class="cl-search__row" href="' + esc(a.url) + '">' +
        '<span class="cl-search__row-image is-article">' + thumb(img) + '</span>' +
        '<span class="cl-search__row-text"><span class="cl-search__row-title">' + esc(a.title) + '</span>' +
        (a.summary_html ? '' : '') + '</span></a>';
    }).join('');
    upgrade(prodList); upgrade(artList);
    if (prodBox) prodBox.hidden = products.length === 0;
    if (artBox) artBox.hidden = articles.length === 0;
    if (empty) empty.hidden = products.length + articles.length > 0;
    if (all) { all.hidden = products.length + articles.length === 0; all.href = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product,article'; }
    if (dflt) dflt.hidden = true;
    if (results) results.hidden = false;
  }
  function query(q) {
    var mine = ++seq;
    var url = predictUrl + '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,article&resources[limit]=6&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor,body,tag';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { if (mine !== seq) return; if (data) render(data, q); })
      .catch(function () { /* the form still submits to /search */ });
  }
  function onInput() {
    var q = (input.value || '').trim();
    if (clear) clear.hidden = q.length === 0;
    clearTimeout(timer);
    if (q.length < 2) { showDefault(); return; }
    timer = setTimeout(function () { query(q); }, 200);
  }
  if (input) input.addEventListener('input', onInput);
  if (clear) clear.addEventListener('click', function () { input.value = ''; showDefault(); input.focus(); });
  el.querySelectorAll('[data-cl-search-term]').forEach(function (b) {
    b.addEventListener('click', function () { input.value = b.dataset.clSearchTerm; onInput(); input.focus(); });
  });
  el.addEventListener('close', function () { if (input) input.value = ''; showDefault(); });
})();

/* ---------- locale suggestion bar ---------- */
(function () {
  if (window.clLocaleBarReady) return;
  window.clLocaleBarReady = true;

  var bar = document.querySelector('[data-cl-locale-bar]');
  if (!bar) return;

  var PICK_KEY = 'cl-region-pick';
  var LANG_KEY = 'cl-region-lang';
  var GEO_KEY = 'cl-region-geo';
  var HIDE_KEY = 'cl-locale-bar-off';

  function read(store, key) {
    try { return window[store] ? window[store].getItem(key) : null; } catch (err) { return null; }
  }
  function write(store, key, value) {
    try { if (window[store]) window[store].setItem(key, value); } catch (err) { /* private mode */ }
  }

  var data = {};
  try { data = JSON.parse(bar.querySelector('[data-cl-bar-data]').textContent) || {}; } catch (err) { data = {}; }
  var names = data.countries || {};
  var langs = data.languages || {};
  var sameMarket = data.sameMarket || [];

  var hereCountry = (bar.getAttribute('data-cl-here-country') || '').toUpperCase();
  var hereLanguage = (bar.getAttribute('data-cl-here-language') || '').toLowerCase();

  var countryInput = bar.querySelector('[data-cl-bar-country]');
  var localeInput = bar.querySelector('[data-cl-bar-locale]');
  var text = bar.querySelector('[data-cl-bar-text]');
  var sub = bar.querySelector('[data-cl-bar-sub]');
  var flag = bar.querySelector('[data-cl-bar-flag]');
  var close = bar.querySelector('[data-cl-bar-close]');
  var drawn = bar.getAttribute('data-cl-flag-set') || '';

  function paintFlag(iso) {
    if (!flag || !iso) return;
    var low = iso.toLowerCase();
    if (drawn.indexOf(',' + low + ',') !== -1) {
      flag.className = 'cl-locale-bar__flag cl-flag cl-flag--' + low;
      flag.textContent = '';
    } else {
      flag.className = 'cl-locale-bar__flag cl-flag cl-flag--code';
      flag.textContent = iso.toUpperCase();
    }
  }

  /* Dismissing is a decision too: it holds for the session, not forever, so a
     visitor who genuinely moves country is offered again on the next visit. */
  if (close) {
    close.addEventListener('click', function () {
      write('sessionStorage', HIDE_KEY, '1');
      bar.setAttribute('hidden', '');
      bar.classList.remove('is-in');
    });
  }

  /* The drawer tells us when the visitor has settled the language themselves,
     so the bar does not sit there suggesting what they just picked. */
  window.clLangSuggestSettled = function (iso) {
    if (iso && iso.toLowerCase() === (bar.getAttribute('data-cl-suggest-language') || '')) {
      bar.setAttribute('hidden', '');
      bar.classList.remove('is-in');
    }
  };

  function show(country, language) {
    var wantCountry = country && country !== hereCountry && names[country] ? country : '';
    var wantLanguage = language && language !== hereLanguage && langs[language] ? language : '';
    if (!wantCountry && !wantLanguage) return;

    /* The detected country is part of the market being served (a multi-country
       market shows its first country alphabetically to everyone): apply it
       without asking. Same domain, same language, nothing for the visitor to
       decide. The form posts in the background; the next page renders with it. */
    if (wantCountry && !wantLanguage && sameMarket.indexOf(wantCountry) !== -1 && countryInput && window.fetch) {
      countryInput.value = wantCountry;
      var form = countryInput.form;
      fetch(form.getAttribute('action') || '/localization', { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function () {
          write('sessionStorage', HIDE_KEY, '1');
          if (window.clRegionShowCountry) window.clRegionShowCountry(wantCountry);
        })
        .catch(function () { /* keep the served country */ });
      return;
    }

    if (wantCountry && countryInput) countryInput.value = wantCountry;
    if (wantLanguage && localeInput) localeInput.value = wantLanguage;
    bar.setAttribute('data-cl-suggest-language', wantLanguage);

    /* Three sentences rather than one with holes in it: the wording changes
       with what actually differs, and a bar that says "in Österreich auf
       Deutsch" when only the country differs reads as a bug. */
    /* Round twenty-three: the wording follows the page language (<html lang>),
       German on the German-speaking markets, English everywhere else. */
    var de = ((document.documentElement.getAttribute('lang') || 'de').slice(0, 2).toLowerCase() === 'de');
    var title, line;
    if (wantCountry && wantLanguage) {
      title = de ? 'Sie scheinen in ' + names[wantCountry] + ' zu sein' : 'You seem to be in ' + names[wantCountry];
      line = de ? 'Preise für diesen Markt, Seite auf ' + langs[wantLanguage] + '.' : 'Prices for this market, page in ' + langs[wantLanguage] + '.';
    } else if (wantCountry) {
      title = de ? 'Sie scheinen in ' + names[wantCountry] + ' zu sein' : 'You seem to be in ' + names[wantCountry];
      line = de ? 'Zu diesem Markt wechseln für Preise und Lieferung.' : 'Switch to this market for prices and delivery.';
    } else {
      title = de ? 'Diese Seite gibt es auf ' + langs[wantLanguage] : 'This page is available in ' + langs[wantLanguage];
      line = de ? 'Sprache wechseln?' : 'Switch language?';
    }
    if (text) text.textContent = title;
    if (sub) sub.textContent = line;
    paintFlag(wantCountry || hereCountry);

    bar.removeAttribute('hidden');
    /* one frame, so the transition has a start state to move from */
    requestAnimationFrame(function () { bar.classList.add('is-in'); });
  }

  function ask() {
    if (read('sessionStorage', HIDE_KEY)) return;
    var pickedCountry = read('localStorage', PICK_KEY);
    var pickedLanguage = read('localStorage', LANG_KEY);
    /* A visitor who has chosen both is never asked again. */
    if (pickedCountry && pickedLanguage) return;
    if (!window.fetch) return;

    var cached = read('sessionStorage', GEO_KEY + '-full');
    if (cached !== null) {
      var parts = cached.split('|');
      show(pickedCountry ? '' : (parts[0] || '').toUpperCase(), pickedLanguage ? '' : (parts[1] || '').toLowerCase());
      return;
    }

    var controller = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, 2500);

    fetch('/browsing_context_suggestions.json', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: controller ? controller.signal : undefined
    })
      .then(function (res) { if (!res.ok) throw new Error('no suggestion'); return res.json(); })
      .then(function (payload) {
        var found = (payload && payload.detected_values) || {};
        var country = (found.country && (found.country.handle || found.country.iso_code)) || '';
        var language = (found.language && (found.language.handle || found.language.iso_code)) || '';
        write('sessionStorage', GEO_KEY + '-full', country + '|' + language);
        show(pickedCountry ? '' : country.toUpperCase(), pickedLanguage ? '' : language.toLowerCase());
      })
      .catch(function () { write('sessionStorage', GEO_KEY + '-full', '|'); })
      .then(function () { clearTimeout(timer); });
  }

  /* Late and idle on purpose: it is the least urgent thing on the page, and a
     bar that slides in during the first paint reads as an ad. */
  if (window.requestIdleCallback) window.requestIdleCallback(ask, { timeout: 4000 });
  else setTimeout(ask, 1800);
})();
